import * as React from 'react';
import {
    UnstyledButton,
    UnstyledButtonProps,
    Group,
    Avatar,
    Text,
    createStyles,
    Menu,
    Button
} from '@mantine/core';
import { IconChevronRight, IconLogout } from '@tabler/icons-react';
import useStore from "../../store";

interface UserButtonProps extends UnstyledButtonProps {
}

const useStyles = createStyles((theme) => ({
    user: {
        display: 'block',
        width: '100%',
        padding: theme.spacing.xs,
        color: '#fff',
        '&:hover': {
            // backgroundColor: theme.fn.lighten(
            //     theme.fn.variant({ variant: 'filled', color: theme.primaryColor }).background!,
            //     0.3
            // ),
            cursor: 'default'
        },
        borderRadius: 6,
    },
    name: {
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center'
    },
    infoWrapper: {
        display: 'flex',
        flexDirection: 'column',
        textAlign: 'right',
        flex: 1,
        flexGrow: 1
    },
    wrapper: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing.md
    }
}));

const UserProfile = ({  }: UserButtonProps) => {

    const { email, phoneNumber, roleName, name, profilePicture } = useStore(state => state.auth);
    const clearStore = useStore(store => store.clearStore);

    const { classes } = useStyles();

    return (
        <div>
            <UnstyledButton className={classes.user}>
                <div className={classes.wrapper}>
                    <Avatar src={profilePicture} radius="xl" />

                    <div className={classes.infoWrapper}>
                        <Text size="sm" weight={400} className={classes.name}>
                            <span style={{ marginRight: '.5rem' }}>{name}</span>
                            <span>/ {roleName} /</span>
                        </Text>

                        <Text color="#cbcbcb" size="xs">
                            {email}
                        </Text>

                        {/*<Text color="#cbcbcb" size="xs">*/}
                        {/*    {phoneNumber}*/}
                        {/*</Text>*/}
                    </div>

                    {/*<IconChevronRight size="0.9rem" stroke={1.5} />*/}
                </div>
            </UnstyledButton>
            <Button
                onClick={() => clearStore()}
                leftIcon={<IconLogout size={20} />}
                fullWidth
            >
                Гарах
            </Button>
            {/*<Menu shadow="md" width={200} trigger={'hover'} position={'right-end'}>*/}
            {/*    <Menu.Target>*/}
            {/*        <UnstyledButton className={classes.user}>*/}
            {/*            <div className={classes.wrapper}>*/}
            {/*                <Avatar src={profilePicture} radius="xl" />*/}

            {/*                <div className={classes.infoWrapper}>*/}
            {/*                    <Text size="sm" weight={400} className={classes.name}>*/}
            {/*                        <span style={{ marginRight: '.5rem' }}>{name}</span>*/}
            {/*                        <span>/ {roleName} /</span>*/}
            {/*                    </Text>*/}

            {/*                    <Text color="#cbcbcb" size="xs">*/}
            {/*                        {email}*/}
            {/*                    </Text>*/}

            {/*                    /!*<Text color="#cbcbcb" size="xs">*!/*/}
            {/*                    /!*    {phoneNumber}*!/*/}
            {/*                    /!*</Text>*!/*/}
            {/*                </div>*/}

            {/*                <IconChevronRight size="0.9rem" stroke={1.5} />*/}
            {/*            </div>*/}
            {/*        </UnstyledButton>*/}
            {/*    </Menu.Target>*/}

            {/*    <Menu.Dropdown>*/}
            {/*        <Menu.Item*/}
            {/*            onClick={() => clearStore()}*/}
            {/*            icon={<IconLogout size={20} />}*/}
            {/*        >*/}
            {/*            Гарах*/}
            {/*        </Menu.Item>*/}
            {/*    </Menu.Dropdown>*/}
            {/*</Menu>*/}
        </div>
    )
}

export default UserProfile;